// extracted by mini-css-extract-plugin
export default {"BotBanner":"BotBannerLight__BotBanner___U03vn"};